import React from "react";
import { HelmetProvider } from "react-helmet-async";
import LivePricesDashboard from "./components/LivePricesDashboard";

export default function App() {
    return (
        <HelmetProvider>
            <LivePricesDashboard />
        </HelmetProvider>
    );
}
